import React, { useState } from 'react';
import { MoldOrder } from '../../types/mold';
import HorizontalStepper from './HorizontalStepper';
import SelectedStepDetail from './SelectedStepDetail';
import Modal from '../shared/Modal';

interface NewStepProgressBarProps {
  moldOrder: MoldOrder;
}

const NewStepProgressBar: React.FC<NewStepProgressBarProps> = ({ moldOrder }) => {
  const [selectedStepIndex, setSelectedStepIndex] = useState(() => {
    // Default to current step or first step
    if (!moldOrder.workflowStructure) return 0;

    const currentStepIndex = moldOrder.workflowStructure.findIndex(
      step => step.shownInTimelineAs === 'current'
    );

    return currentStepIndex >= 0 ? currentStepIndex : 0;
  });
  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleStepClick = (stepIndex: number) => {
    setSelectedStepIndex(stepIndex);
    setIsOpenModal(true);
  };

  if (!moldOrder.workflowStructure || moldOrder.workflowStructure.length === 0) {
    return (
      <div className="w-full mx-auto p-6 bg-gray-50 rounded-lg">
        <div className="text-center">
          <p className="text-gray-500">ไม่พบข้อมูลขั้นตอนการทำงาน</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full mx-auto space-y-6">
      {/* Horizontal Stepper Section */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div className="p-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900 mb-1">ขั้นตอนการทำงาน</h3>
          <p className="text-sm text-gray-600">คลิกที่ขั้นตอนเพื่อดูรายละเอียด • เลื่อนซ้าย-ขวาเพื่อดูขั้นตอนทั้งหมด</p>
        </div>

        <div className="p-2">
          <HorizontalStepper
            moldOrder={moldOrder}
            selectedStepIndex={selectedStepIndex}
            onStepClick={handleStepClick}
          />
        </div>
        
        {/* Selected Step Detail Panel - Always Visible */}
        {isOpenModal && <Modal
          onClose={() => setIsOpenModal(false)}
          hideTopPadding={true}
          isBackgroundTransparent={true}>
          <div className="p-4">
            <h2 className="text-lg font-semibold text-gray-900 mb-1">รายละเอียดขั้นตอน</h2>
            <h4 className="text-xs text-gray-800 mb-4">ขั้นตอนที่ {selectedStepIndex + 1} จาก {moldOrder.workflowStructure.length}</h4>
            <SelectedStepDetail
              moldOrder={moldOrder}
              selectedStepIndex={selectedStepIndex}
            />
          </div>
        </Modal>}
      </div>
    </div>
  );
};

export default NewStepProgressBar;
